var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOptic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Eye-Optic--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Eye Optic Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-optic--health-medical-eye-optic"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2095",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.99989 3.29974c-4.2596 0 -6.047986 4.5219 -6.047986 4.60013C0.951904 7.97811 2.74029 12.5 6.99989 12.5c4.25961 0 6.04801 -4.52189 6.04801 -4.60013 0 -0.07823 -1.7884 -4.60013 -6.04801 -4.60013",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2096",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.2991 5.65812 0.5 3.91425",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2097",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.12438 3.6123 4.4563 1.5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2099",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.7288 5.68941 13.5 3.91425",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2100",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.87964 3.61231 9.54375 1.5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1919",
    stroke: "#ffffff",
    d: "M5.258 7.9a1.742 1.742 0 1 0 3.484 0 1.742 1.742 0 1 0 -3.484 0",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOptic);
export default __webpack_public_path__ + "static/media/Eye-Optic.8d703379386f959fab0e558e12e7126e.svg";
export { ForwardRef as ReactComponent };